import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Record} from 'immutable';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Set} from 'immutable';
import classnames from 'classnames';
import * as actions from '../actions';
import {Request, POST, DELETE} from 'requests';
import {default as RequestsMixin, IS_DONE, HAS_FAILED} from 'requests/RequestsMixin';
import {ResourcesMatching, HasErrors} from 'requests/components';
import {default as PasteOrDropzone, TYPEFACE, DROPZONE} from './PasteOrDropzone';
import {TYPEFACE_WEIGHTS, TYPEFACE_STYLES} from '../settings';
import {default as TypefaceSubsetting} from './TypefaceSubsetting';

const NewTypeface = Record({
  kitId: null,
  family: null,
  weight: null,
  style: null,
  subsetting: null,
  characterSets: null,
});

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const UploadTypefaceForm = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    characterSets: PropTypes.object.isRequired,
    typefaceSettings: PropTypes.object.isRequired,
    onUploadTypefaceClicked: PropTypes.func.isRequired,
    isAllowed: PropTypes.bool.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      subsetting: this.props.typefaceSettings.defaultSubsetting,
      characterSets: Set(this.props.typefaceSettings.characterSets),
      uploadFailed: false,
    };
  },

  transitions(register) {
    register({
      request: this.requests.uploadWorkingSetTypeface,
      to: HAS_FAILED,
      call(rm) {
        this.clearRequests();

        this.setState({
          uploadFailed: true,
        });

        this.state.dropzone.removeAllFiles();
      },
    });

    register({
      request: this.requests.uploadWorkingSetTypeface,
      to: IS_DONE,
      call(rm) {
        browserHistory.push(`/kits/${this.props.kitToken}/typefaces`);
      },
    });
  },

  handleDropzoneInit(dropzone) {
    this.setState({
      dropzone,
    });
  },

  handleSubsettingChanged(subsetting) {
    this.setState({
      subsetting,
    });
  },

  handleCharacterSetChanged(id, isChecked) {
    const {characterSets} = this.state;

    this.setState({
      characterSets: (isChecked) ? characterSets.add(id) : characterSets.delete(id),
    });
  },

  uploadRecord() {
    return NewTypeface({
      kitId: this.props.kitToken,
      family: this.refs.family.value,
      weight: this.refs.weight.value,
      style: this.refs.style.value,
      subsetting: this.state.subsetting,
      characterSets: this.state.characterSets,
    });
  },

  handleUploadClicked(event) {
    event.preventDefault();

    this.props.onUploadTypefaceClicked();

    const record = this.uploadRecord();
    const request = new Request({
      url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      method: POST,
      record,
    });

    this.setState({
      uploadFailed: false,
    });

    this.setRequest({
      uploadWorkingSetTypeface: request,
    }, {skipDispatch: true});

    if (this.props.isAllowed) {
      this.props.dispatch(
        actions.createWorkingSetTypeface(request, record, this.state.dropzone)
      );
    }
  },

  renderError() {
    const {isAllowed} = this.props;
    const {uploadFailed} = this.state;
    let error = null;

    if (!isAllowed) {
      error = (
        <div id="build-error" className="alert alert-primary bg-body" role="alert">
          <strong>Well shoot!</strong> You&apos;ll have to <a href="/upgrade">upgrade</a> before you can add another typeface.
        </div>
      );
    } else if (uploadFailed) {
      error = (
        <div id="build-error" className="alert alert-danger bg-body" role="alert">
          <strong>Dangit!</strong> There was an issue uploading your custom typeface. Our support team has been notified.
        </div>
      );
    }

    return error;
  },

  renderUploadIconButton() {
    const rm = this.resourceManager();
    let uploadTypefaceButtonElement = null;
    const className = classnames(
      'btn',
      'btn-primary',
      'btn-block',
      'btn-lg'
    );

    if (rm.requests.isQueued(this.requests.uploadWorkingSetTypeface)) {
      uploadTypefaceButtonElement = (
        <button className={classnames(className, 'disabled')}>
          Uploading typeface&hellip;
        </button>
      );
    } else {
      uploadTypefaceButtonElement = (
        <button onClick={this.handleUploadClicked} className={className}>
          Upload Typeface <i className="ficon ficon-check-circle p-xs-l-xs" />
        </button>
      );
    }

    return uploadTypefaceButtonElement;
  },

  render() {
    const {
      characterSets,
    } = this.props;
    const rm = this.resourceManager();
    const makeOption = (value) => {
      return <option key={value} value={value}>{value}</option>;
    };
    const weightOptions = TYPEFACE_WEIGHTS.map(makeOption);
    const styleOptions = TYPEFACE_STYLES.map(makeOption);
    const formGroupClassName = classnames('form-group', 'row', 'string', 'required');
    const familyFormGroupClassName = classnames(
      formGroupClassName,
      {'has-danger': rm.requests.errorsFor(this.requests.uploadWorkingSetTypeface).get('family')}
    );

    return (
      <ResourcesMatching manager={rm}>
        <div className="row">
          <div className="col-xs-9 col-xs-offset-1">
            <form className="simple_form form-horizontal">
              {this.renderError()}
              <div className={familyFormGroupClassName}>
                <label className="string required col-xs-3 form-control-label p-xs-r-sm">Family <span title="Required">*</span></label>
                <div className="col-xs-8">
                  <input ref="family" className="string required form-control" type="text" />
                  <HasErrors request={this.requests.uploadWorkingSetTypeface} errorKey="family">
                    <span className="text-help text-muted p-xs-t-xs">{rm.requests.errorsFor(this.requests.uploadWorkingSetTypeface).get('family')}</span>
                  </HasErrors>
                  <p className="text-muted p-xs-t-xs">Name of your typeface family. Identical typeface families will be grouped together.</p>
                </div>
              </div>

              <PasteOrDropzone
                onDropzoneInit={this.handleDropzoneInit}
                type={TYPEFACE}
                error={rm.requests.errorsFor(this.requests.uploadWorkingSetTypeface).get('typeface')}
                wrapperClassName="col-xs-8"
                which={DROPZONE}
              />

              <div className="form-group row select required">
                <label className="select required col-xs-3 form-control-label p-xs-r-sm">Weight <span title="Required">*</span></label>
                <div className="col-xs-8">
                  <select ref="weight" className="select required form-control">
                    {weightOptions}
                  </select>
                </div>
              </div>

              <div className="form-group row select required">
                <label className="select required col-xs-3 form-control-label p-xs-r-sm">Style <span title="Required">*</span></label>
                <div className="col-xs-8">
                  <select ref="style" className="select required form-control">
                    {styleOptions}
                  </select>
                </div>
              </div>

              <div className="form-group row required">
                <label className="required col-xs-3 form-control-label p-xs-r-sm">
                  Character Subsetting <span title="Required">*</span>
                </label>
                <div className="col-xs-9">
                  <TypefaceSubsetting
                    subsetting={this.state.subsetting}
                    selectedCharacterSetIds={this.state.characterSets}
                    characterSets={characterSets}
                    onSubsettingChanged={this.handleSubsettingChanged}
                    onCharacterSetChanged={this.handleCharacterSetChanged}
                  />
                </div>
              </div>

              <div className="form-group row m-xs-b-lg">
                <div className="col-xs-8 col-xs-offset-3">
                  {this.renderUploadIconButton()}
                </div>
              </div>
            </form>
          </div>
        </div>
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(UploadTypefaceForm);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/UploadTypefaceForm.js